import React, { useEffect } from 'react'
import styles from './style.module.scss'
import { useHistory, useLocation, useParams } from 'react-router'
import { SectionWrapper } from '@Root/HOCs'
import { CreateModuleInstance } from './Create'
import { EditModuleInstance } from './Edit'
import { useDispatch, useSelector } from 'react-redux'
import { modalActions } from '@Root/store'
import { studentCourseSessionSelectors, studentCourseSessionActions } from '@Store/studies/studentCourseSession/index'
import { moduleInstancesActions } from '@Store/studies'
import { fieldTooltipManagerActions } from '@Store/fieldTooltipManager/index'
import { hesaActions } from '@Store/contact/person'

export const ModuleInstancePage = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const programmeRecord = useSelector(studentCourseSessionSelectors.programmeRecord)
  const pathname = location.pathname
  const isNew = pathname.includes('new')
  const isDuplicate = pathname.includes('duplicate')
  const { studyProgrammeId, contactId } = useParams()
  const DEFAULT_URL = `/home/studies/programmes/study/${contactId}/${studyProgrammeId}/module_instance`

  useEffect(() => {
    dispatch(studentCourseSessionActions.get({ studyProgrammeId, isCopy: isDuplicate }))
    dispatch(moduleInstancesActions.getOptions())
    dispatch(fieldTooltipManagerActions.getHesaDescriptions())
    dispatch(hesaActions.getDynamicOptions({ contactId }))
    return () => {
      dispatch(studentCourseSessionActions.clearData({}))
      dispatch(moduleInstancesActions.clearData())
    }
  }, [])

  const onOpenDescriptionModal = (description, title) => {
    new Promise((resolve, reject) => {
      dispatch(modalActions.showModal('NotificationModal', { text: description, clickRejectButtonHandler: reject, clickResolveButtonHandler: resolve, title }))
    }).finally(() => dispatch(modalActions.hideModal()))
  }

  const handleBack = () => {
    history.push(DEFAULT_URL)
  }
  return (
    <SectionWrapper hasBackButton backButtonText={'Module Instances'} clickBackButtonHandler={handleBack} activeName>
      <div className={styles.sections}>
        {isNew ? (
          <CreateModuleInstance onOpenDescriptionModal={onOpenDescriptionModal} programmeRecord={programmeRecord} handleBack={handleBack} />
        ) : (
          <EditModuleInstance onOpenDescriptionModal={onOpenDescriptionModal} programmeRecord={programmeRecord} />
        )}
      </div>
    </SectionWrapper>
  )
}
